<template>
  <div class="item" :class="{ 'open-item': open, 'radial-item': radial }">
    <div class="item-hat" @click="click">
      <div class="item-number">{{ item.number }}</div>
      <div class="item-title">{{ item.title }}</div>
      <arrow-icon-white :direction="open ? 'up' : 'down'" v-if="item.children" />
    </div>
    <div class="item-coat">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ArrowIconWhite from '@/components/icons/ArrowIconWhite'

export default {
  components: { ArrowIconWhite },
  props: {
    item: Object,
    radial: Boolean
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    click () {
      if (this.item.children) {
        this.open = !this.open
      } else {
        this.$router.push(`/rules/article/${this.item.id}`)
      }
    }
  }
}
</script>

<style scoped>
.item { border: 1px solid white; background: #007354 !important; color: white; margin-top: 3px;
margin-bottom: 3px; margin-right: 10px; }
.item-hat { align-items: center; cursor: pointer; display: flex; min-height: 40px; -webkit-transition: background-color .3s; -moz-transition: background-color .3s; -o-transition: background-color .3s; transition: background-color .3s; font-size: 14px; }
.item-hat:hover { background: rgba(255, 255, 255, .05); }
.radial-item .item-hat { border-bottom-left-radius: 5px; border-top-left-radius: 5px; }
.item-number { padding: 0 10px; }
.item-title { flex: 1; padding: 5px 0; }
.item-coat { display: none; }
.open-item > .item-coat { display: block; }
.white-color { color: white !important; }
.grow { margin-top: 5px; }
</style>



// WEBPACK FOOTER //
// src/components/rules/menu/Item.vue